<template>
  <div>
    <basic-container>
      <div>
        <el-form :model="goodsForm">
          <!-- 产品名称 -->
          <el-form-item label="产品名称" style="display: flex;width:300px;">
            <el-input v-model="goodsForm.name" placeholder="请输入产品名称" clearable></el-input>
          </el-form-item>
          <!-- 产品别名 -->
          <el-form-item label="产品别名" style="display: flex;width:300px;">
            <el-input v-model="goodsForm.alias" placeholder="请输入产品别名" clearable></el-input>
          </el-form-item>
          <!-- 产品价格 -->
          <el-form-item label="产品价格" style="display: flex;width:300px;">
            <el-input v-model="goodsForm.price" placeholder="请输入产品价格" clearable></el-input>
          </el-form-item>
          <!-- 返利金额rebate -->
          <el-form-item label="返利金额" style="display: flex;width:300px;">
            <el-input v-model="goodsForm.rebate" placeholder="请输入返利金额" clearable></el-input>
          </el-form-item>
           <!-- 推广费 -->
           <el-form-item label="推广费用" style="display: flex;width:300px;">
            <el-input v-model="goodsForm.laborCost" placeholder="请输入推广费" clearable></el-input>
          </el-form-item>
          <!-- 换新提醒配置 -->
          <el-form-item label="换新提醒配置">
            <el-table :data="goodsFormData" border style="width: 100%; margin-top: 20px">
              <el-table-column prop="name" label="显示名称" min-width="150">
                <template slot-scope="scope">
                  <el-input v-model="scope.row.name" placeholder="请输入名称"></el-input>
                </template>
              </el-table-column>
              <el-table-column prop="time" label="到期时间" min-width="150">
                <template slot-scope="scope">
                  <div style="display: flex; align-items: center;">
                    <el-input v-model.number="scope.row.time" placeholder="请输入到期时间" type="number" min="1"></el-input>
                    <el-select v-model="scope.row.unit" placeholder="请选择时间单位" clearable style="margin-right: 10px;">
                      <el-option v-for="unit in units" :key="unit.value" :label="unit.valueName"
                        :value="unit.value"></el-option>
                    </el-select>
                  </div>
                </template>
              </el-table-column>
            </el-table>
          </el-form-item>
        </el-form>
        <el-form :model="dynamicForm">
          <!-- 动态表单配置 -->
          <el-form-item label="动态表单配置">
            <el-table :data="dynamicFormData" border style="width: 100%; margin-top: 20px">
              <el-table-column prop="fieldName" label="显示名称" min-width="150">
                <template slot-scope="scope">
                  <el-input v-model="scope.row.fieldName" placeholder="请输入名称"></el-input>
                </template>
              </el-table-column>
              <el-table-column prop="inputType" label="控件类型" min-width="150">
                <template slot-scope="scope">
                  <el-select v-model="scope.row.inputType" placeholder="请选择控件类型" clearable>
                    <el-option v-for="inputType in inputTypes" :key="inputType.id" :label="inputType.name"
                      :value="inputType.id">
                    </el-option>
                  </el-select>
                </template>
              </el-table-column>
              <el-table-column prop="dataSource" label="数据源" min-width="150">
                <template slot-scope="scope">
                  <el-select v-model="scope.row.dataSource" placeholder="请选择数据源" clearable>
                    <el-option v-for="dataSource in dataSources" :key="dataSource.id" :label="dataSource.valueName"
                      :value="dataSource.id">
                    </el-option>
                  </el-select>
                </template>
              </el-table-column>
              <el-table-column prop="isNull" label="是否为空" width="150">
                <template slot-scope="scope">
                  <el-radio-group v-model="scope.row.isNull">
                    <el-radio label="YES">是</el-radio>
                    <el-radio label="NO">否</el-radio>
                  </el-radio-group>
                </template>
              </el-table-column>
              <el-table-column prop="sort" label="排序" width="150">
                <template slot-scope="scope">
                  <el-input v-model="scope.row.sort"></el-input>
                </template>
              </el-table-column>
            </el-table>
          </el-form-item>
        </el-form>
      </div>
      <div style="width: 100%; display: flex; flex-flow: row nowrap; justify-content: center; margin-top: 20px">
        <el-button type="primary" size="small" @click="goBack" icon="el-icon-back">返回上一页</el-button>
      </div>
    </basic-container>
  </div>
</template>

<script>
import { getGoodsForm } from "@/api/work/waterProject/purWaterGoods";
import {
  findDataSourceFields,
  findDataSourceAll,
} from "@/api/work/dynamicForm";
export default {
  data() {
    return {
      units: [
        { value: 'DAY', valueName: '天' },
        { value: 'MOON', valueName: '月' },
        { value: 'YEAR', valueName: '年' },
      ],
      goodsForm: {
        name: '',
        id: '', // 添加id字段，用于提交时区分是新增还是修改
        filters: [] // 存放从接口获取的原始数据
      },
      goodsFormData: [], // 用于编辑的临时数据
      isPas: false,
      inputTypes: [],
      dataSources: [],
      dynamicForm: {
        formName: '',
        formType: ''
      },
      dynamicTypes: [], // 确保这是一个数组
      dynamicFormData: [] // 确保这是一个数组
    };
  },
  created() {
    findDataSourceFields().then(res => {
      let data = JSON.parse(res.data);
      this.inputTypes = data;
    });
    findDataSourceAll().then(res => {
      let data = JSON.parse(res.data);
      this.dataSources = data.rows;
    });
    const goodsId = this.$route.query.GoodsId; // 假设产品ID通过路由参数传递
    if (goodsId) {
      this.fetchGoodsData(goodsId);
    }
  },
  methods: {
    fetchGoodsData(goodsId) {
      getGoodsForm(goodsId).then(res => {
        if (res.code === "200") {
          const data = JSON.parse(res.data).rows[0];
          this.goodsForm = data;
          this.goodsFormData = data.filters.map(filter => ({ ...filter }));
          this.dynamicFormData = data.dynamicFormRequest.fields.map(field => ({
            fieldName: field.fieldName,
            inputType: this.inputTypes.find(inputType => inputType.id == field.inputType).name,
            dataSource: field.dataSource,
            isNull: field.isNull,
            sort: field.sort
          }));
        } else {
          this.$message({
            showClose: true,
            message: res.message,
            type: "error"
          });
        }
      });
    },
    goBack() {
      let item = {
        close: true,
        label: "查看净水产品",
        value: "/work/waterProject/purWaterGoods/view"
      };
      this.$store.commit("DEL_TAG", item);
      this.$router.go(-1);
    }
  }
};
</script>

<style scoped></style>
